/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierLoginUrlResponse
 */
export interface CarrierLoginUrlResponse {
  /**
   *
   * @type {string}
   * @memberof CarrierLoginUrlResponse
   */
  url: string;
}

/**
 * Check if a given object implements the CarrierLoginUrlResponse interface.
 */
export function instanceOfCarrierLoginUrlResponse(
  value: object,
): value is CarrierLoginUrlResponse {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function CarrierLoginUrlResponseFromJSON(
  json: any,
): CarrierLoginUrlResponse {
  return CarrierLoginUrlResponseFromJSONTyped(json, false);
}

export function CarrierLoginUrlResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierLoginUrlResponse {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function CarrierLoginUrlResponseToJSON(
  json: any,
): CarrierLoginUrlResponse {
  return CarrierLoginUrlResponseToJSONTyped(json, false);
}

export function CarrierLoginUrlResponseToJSONTyped(
  value?: CarrierLoginUrlResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
